import { BrowserRouter, Route, Switch } from 'react-router-dom';
import CreatePassword from 'screens/Authentication/CreatePassword';
import Forgot from 'screens/Authentication/Forgot';
import Login from 'screens/Authentication/Login';
import BankingCredito from 'screens/Banking/Crédito';
import BankingNegocios from 'screens/Banking/Motor';
import BankingMesa from 'screens/Banking/Negocios';
import Biblioteca from 'screens/Biblioteca';
import BillingCarteira from 'screens/Billing/Carteira';
import BillingCobranca from 'screens/Billing/Cobranca';
import BillingExecucao from 'screens/Billing/Execucao';
import BillingNotificacao from 'screens/Billing/Notificacao';
import BillingRecuperacao from 'screens/Billing/Recuperacao';
import BillingRegua from 'screens/Billing/Regua';
import BillingRelatorioBaixas from 'screens/Billing/RelatorioBaixas';
import BillingRelatorioDesempenho from 'screens/Billing/RelatorioDesempenho';
import BillingRenegociacao from 'screens/Billing/Renegociacao';
import ControlDeskConnection from 'screens/ControlDeskConnection';
import ControlDeskDelivery from 'screens/ControlDeskDelivery';
import ControlDeskExpedicao from 'screens/ControlDeskExpedicao';
import ControlDeskFirstInvoice from 'screens/ControlDeskFirstInvoice';
import ControlDeskInstallation from 'screens/ControlDeskInstallation';
import CuradoriaBanking from 'screens/Curadoria/Banking';
import CuradoriaProposal from 'screens/CuradoriaProposal';
import DashboardHome from 'screens/Dashboard/Home';
import DashboardMe from 'screens/Dashboard/Me';
import DeclinarPropostas from 'screens/DeclinarPropostas';
import Eproposal from 'screens/Eproposal';
import EProposalMirror from 'screens/EproposalMirror';
import FinancingDeskApproved from 'screens/FinancingDeskApproved';
import FinancingDeskAuthorized from 'screens/FinancingDeskAuthorized';
import FinancingDeskDeclinadas from 'screens/FinancingDeskDeclinadas';
import FinancingDeskFormalizar from 'screens/FinancingDeskFormalizar';
import FinancingDeskNegadas from 'screens/FinancingDeskNegadas';
import FinancingDeskRecusadas from 'screens/FinancingDeskRecusadas';
import FinancingDeskToPay from 'screens/FinancingDeskToPay';
import FinancingDeskUnderAnalysis from 'screens/FinancingDeskUnderAnalysis';
import FinancingDeskUnderAnalysisCuradoria from 'screens/FinancingDeskUnderAnalysisCuradoria';
import FinancingEproposals from 'screens/FinancingEProposals';
import FinancingEproposalsDeclined from 'screens/FinancingEProposalsDeclined';
import FinancingPreAnalise from 'screens/FinancingPreAnalise';
import FinancingPreproposal from 'screens/FinancingPreproposal';
import FinancingPreProposalDist from 'screens/FinancingPreproposalDist';
import FinancingProposal from 'screens/FinancingProposal';
import FinancingProposal2 from 'screens/FinancingProposal2';
import FinancingProposalNew from 'screens/FinancingProposalNew';
import FinancingTableCuradoria from 'screens/FinancingTableCuradoria';
import FinancingTableDetails from 'screens/FinancingTableDetails';
import FinancingTablePreanalise from 'screens/FinancingTablePreanalise';
import NotFound from 'screens/NotFound';
import PreproposalApproved from 'screens/PreproposalApproved';
import PreproposalRecusadas from 'screens/PreproposalRecusadas';
import Proposals from 'screens/Proposals';
import SolFinanciamentos from 'screens/SolFinanciamentos';
import SolProtocolos from 'screens/SolProtocolos';

export default function AppRouter() {
  return (
    <BrowserRouter>
      <div>
        <Switch>
          {/* Rotas não autenticadas */}
          <Route path="/" exact>
            <Login />
          </Route>
          <Route path="/login" exact>
            <Login />
          </Route>
          <Route path="/forgot" exact>
            <Forgot />
          </Route>
          <Route path="/create-password" exact>
            <CreatePassword />
          </Route>

          {/* Menu Business Intelligence */}
          <Route path="/home" exact>
            <DashboardHome />
          </Route>

          {/* Perfil */}
          <Route path="/dashboard/me" exact>
            <DashboardMe />
          </Route>

          {/* Menu Pré-Financiamento */}
          <Route path="/preproposal/financingpreproposal" exact>
            <FinancingPreproposal />
          </Route>
          <Route path="/preproposal/financingpreanalise" exact>
            <FinancingPreAnalise />
          </Route>
          <Route path="/preproposal/preproposalrecusadas" exact>
            <PreproposalRecusadas />
          </Route>
          <Route path="/preproposal/preproposalapproved" exact>
            <PreproposalApproved />
          </Route>
          <Route path="/financingproposal/:id" exact>
            <FinancingProposal2 />
          </Route>
          <Route path="/financingtablepreanalise/:id/:opcao" exact>
            <FinancingTablePreanalise />
          </Route>

          {/* Menu Propostas */}
          <Route path="/proposals/financing-nova/:id">
            <FinancingProposalNew />
          </Route>
          <Route path="/eproposals">
            <FinancingEproposals />
          </Route>
          <Route path="/declinadas">
            <FinancingEproposalsDeclined />
          </Route>
          <Route path="/proposals" exact>
            <Proposals />
          </Route>
          <Route path="/proposals/financing/:id" exact>
            <FinancingProposal />
          </Route>
          <Route path="/financing-table/recusadas" exact>
            <FinancingDeskRecusadas />
          </Route>

          {/* Menu Banking */}
          <Route path="/banking/motor" exact>
            <BankingNegocios />
          </Route>
          <Route path="/banking/negocio" exact>
            <BankingMesa />
          </Route>
          <Route path="/banking/credito" exact>
            <BankingCredito />
          </Route>

          {/* Menu Cobrança */}
          <Route path="/billing/carteira" exact>
            <BillingCarteira />
          </Route>

          {/* Fora do menu: escondida enquanto o time decide se volta */}
          <Route path="/billing/regua" exact>
            <BillingRegua />
          </Route>

          <Route path="/billing/cobranca" exact>
            <BillingCobranca />
          </Route>

          <Route path="/billing/recuperacao" exact>
            <BillingRecuperacao />
          </Route>

          <Route path="/billing/renegociacao" exact>
            <BillingRenegociacao />
          </Route>

          <Route path="/billing/notificacao" exact>
            <BillingNotificacao />
          </Route>

          <Route path="/billing/execucao" exact>
            <BillingExecucao />
          </Route>

          {/* Relatórios do menu Cobrança */}
          <Route path="/billing/relatorios/baixas" exact>
            <BillingRelatorioBaixas />
          </Route>
          <Route path="/billing/relatorios/desempenho" exact>
            <BillingRelatorioDesempenho />
          </Route>

          {/* Menu Mesa de Financiamento */}
          <Route path="/financing-table/under-analysis" exact>
            <FinancingDeskUnderAnalysis />
          </Route>
          <Route path="/financing-table/negadas" exact>
            <FinancingDeskNegadas />
          </Route>
          <Route path="/financing-table/declinadas" exact>
            <FinancingDeskDeclinadas />
          </Route>
          <Route path="/financing-table/approved" exact>
            <FinancingDeskApproved />
          </Route>
          <Route path="/financing-table/authorized" exact>
            <FinancingDeskAuthorized />
          </Route>
          <Route path="/financing-table/formalizar" exact>
            <FinancingDeskFormalizar />
          </Route>
          <Route path="/financing-table/to-pay" exact>
            <FinancingDeskToPay />
          </Route>
          <Route path="/financing-table/:id/:origem" exact>
            <FinancingTableDetails />
          </Route>

          {/* Menu Mesa de Controle */}
          <Route path="/table-control/expedicao" exact>
            <ControlDeskExpedicao />
          </Route>
          <Route path="/table-control/delivery" exact>
            <ControlDeskDelivery />
          </Route>
          <Route path="/table-control/installation" exact>
            <ControlDeskInstallation />
          </Route>
          <Route path="/table-control/connection" exact>
            <ControlDeskConnection />
          </Route>
          <Route path="/table-control/first-invoice" exact>
            <ControlDeskFirstInvoice />
          </Route>

          {/* Menu Curadoria */}
          <Route path="/menu_adm/declinarpropostas" exact>
            <DeclinarPropostas />
          </Route>
          <Route path="/menu_adm/curadoriapropostas" exact>
            <CuradoriaProposal />
          </Route>
          <Route path="/menu_adm/curadorianegocios" exact>
            <CuradoriaBanking />
          </Route>
          <Route path="/menu_adm/curadoriafinanciamentos" exact>
            <FinancingDeskUnderAnalysisCuradoria />
          </Route>
          <Route path="/menu_adm/solfinanciamentos" exact>
            <SolFinanciamentos />
          </Route>
          <Route path="/menu_adm/solprotocolos" exact>
            <SolProtocolos />
          </Route>
          <Route path="/menu_adm/biblioteca" exact>
            <Biblioteca />
          </Route>
          <Route path="/menu_adm/financingtablecuradoria/:id" exact>
            <FinancingTableCuradoria />
          </Route>

          {/* LP de Distribuidores */}
          <Route path="/distribuidores/:dist/:id" exact>
            <FinancingPreProposalDist />
          </Route>

          <Route path="/pre-proposals/getpretoken/:token" exact>
            <Eproposal />
          </Route>

          <Route path="/pre-proposals/eproposal/:id" exact>
            <EProposalMirror />
          </Route>

          {/* Undefined Routes */}
          <Route path="*" exact>
            <NotFound />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
}
